import showCaseUnauthorizedMeta from './showCaseUnauthorizedMeta.js'

export default [
  {
    path: '/showcase',
    name: 'showcase',
    alias: ['/showcase/'],
    component: () => import('@/views/ShowCaseUnauthorized/ShowcaseAllTradeProductView.vue'),
    props: {
      title: 'Торговые процедуры',
    },
    meta: {
      ...showCaseUnauthorizedMeta,
      layout: 'main-sidebar-layout',
    },
  },
  {
    path: '/showcase/new',
    name: 'showcase-new',
    component: () => import('@/views/ShowCaseUnauthorized/ShowcaseNewView.vue'),
    props: {
      title: 'Новые',
    },
    meta: {
      ...showCaseUnauthorizedMeta,
      layout: 'main-sidebar-layout',
    },
  },
]
